
<template>
  <div class="patents">
    <div>
      <div class="title-box3">
        <el-image 
          style="height: 30px; width: 30px; margin-top: 5px;"
          src="../../static/image/icon.png">
        </el-image>
        <h2 style="width: 200px; margin-top: 0px; margin-left: 10px;">发明专利</h2>
      </div>
      <ul style="list-style-type: none; padding-left: 0;">
        <li v-for="(item, index) in patents" :key="'pat-' + index" class="infos">
          <span class="custom-counter">{{ patents.length - index + '. ' }}</span>
          <span>{{ item.value }}</span>
        </li>
      </ul>
    </div>

    <div style="margin-top: 40px;">
      <div class="title-box3">
        <el-image 
          style="height: 30px; width: 30px; margin-top: 5px;"
          src="../../static/image/icon.png">
        </el-image>
        <h2 style="width: 200px; margin-top: 0px; margin-left: 10px;">软件著作权</h2>
      </div>

      <ul style="list-style-type: none; padding-left: 0;">
        <li v-for="(item, index) in copyrights" :key="'copy-' + index" class="infos">
          <span class="custom-counter">{{ copyrights.length - index + '. ' }}</span>
          <span>{{ item.value }}</span>
        </li>
      </ul>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Patents',
  data() {
    return {
      patents: [
        { value: '余佩嘉, 裴之蕈, 王崎, 等;发明授权：一种基于特征交互与通道注意力的空谱联合超分辨率方法;2025.06.03,ZL202410736992.8' },
        { value: '王崎, 谢雨珊, 董新宇, 等;发明授权：一种基于概念增强的零样本植物病害图像表征描述生成方法;2025.06.27,ZL202411599788.2' },
        { value: '余佩嘉, 淡玉娇, 王崎, 等;发明授权：基于提示驱动大模型的主粮作物病害分级方法及系统;2025.06.24,ZL202411617407.9' },
        { value: '王崎, 刘阳, 吴雪, 等;发明授权：基于病害农药知识图谱的长尾病害识别用药一体化方法;2025.04.22,ZL202411936605.1' },
        { value: '王崎, 王玉祥, 吴雪, 等;发明授权：一种基于空-频域层次学习的小样本细粒度图像分类方法;2025.08.12,ZL202411635304.5' },
        { value: '王崎, 吴兴财, 王亚洲, 等;发明授权：基于无人机高空纹理成像的植物病虫害检测设备及方法;2025.08.19,ZL202411664358.4' },
        { value: '王崎, 万潇阳, 王玉祥, 等;发明授权：田间复杂光照下的密集叶片检测方法、系统及计算设备;2025.09.09,ZL202510885660.0' },
        { value: '余佩嘉, 余娅, 王崎, 等;发明授权：基于位置引导病灶表征学习的植物叶片病害严重程度评估方法;2025.09.09,ZL202411583157.1' },
        { value: '王崎, 袁志豪, 吴雪, 等;发明授权：基于对比特征库的渐进式作物病害分类方法及系统;2025.09.12,ZL202510847445.1' },
        { value: '王崎, 葛庆龙, 吴晨阳, 等;发明授权：一种基于离散序列点转换的神经元连接方法;2025.09.23' },
        { value: '王建超, 王岚颖, 王崎, 等;发明授权：基于双目流深度估计的人体姿态关键角度计算方法;2025.02.24,ZL202510203984.1' },
        { value: '王崎, 姜思君;发明授权：一种基于双目视觉的植物叶柄角度测量算法;2026.01.06' },
        { value: '王崎, 裴之蕈, 吴兴财, 等;发明授权：一种基于可见光图像的农业多光谱视觉重构方法;2024.07.12,ZL202211329001.1' },
        { value: '陈攀峰, 邓星志, 王崎, 等;发明公布：一种大模型的轻量化参数高效微调方法;2025.06' },
        { value: '易永亮, 王崎, 姜思君, 等;发明公布：一种基于双目成像的非侵入性树木生长高度测量算法;2024' },
        { value: '王崎,黄前顶,等;发明授权：一种轻量化植物病虫害目标检测模型的构建和训练方法;2024.02.20,ZL202210769212.0' },
        { value: '王崎,吴兴财,等;发明授权：基于多粒度图文语义学习的文本引导图像修复模型及方法;2023.09.19,ZL202310796408.3' },
        { value: '王崎,李青雷,等;发明授权：一种基于特征向量的离散相似度匹配分类方法;2023.09.05,ZL202310756831.0' },
        { value: '张天瀚,王崎,等;发明授权：一种复杂场景下的作物三维目标检测方法;2023.09.01,ZL202310791383.8' },
        { value: '邓宏宇,王崎,等;发明授权：一种基于窗口自注意与多尺度机制的图像密集描述方法;2023.09.26,ZL202310822911.1' },
        { value: '王崎,吴晨阳,等;发明授权：一种基于小规模参数矩阵计算特征图边界的重构方法;2023.05.26,ZL202210229602.9' },
        { value: '王崎,颜润明,等;发明授权：一种基于通用振镜与视觉测速的飞行打标系统和控制方法;2023.09.15,ZL201710736104.2' },
        { value: '刘文印,王崎,等;发明授权：一种视频关键帧提取方法、系统及设备和存储介质;2023.07.28, ZL201810523467.2.' },
        { value: '刘文印,王崎,等;一种目标监测方法、系统及设备和存储介质;2024.02.20, ZL201810522083.9.' },
        { value: '肖源源,黄杨,王崎,等;一种基于多模态图像融合的杂草侵扰率预测方法,2024.05.22,ZL202410636283.2' },
        { value: '张邦梅,李耀羲,王崎,等;一种基于数量监督的农作物计数方法;2024.5.21,ZL202410629145.1' },
        { value: '陈攀峰,赵克君,王崎,等;一种基于语义保留与重构的图像文本控制描述生成方法;2024.5.24,ZL202410651350.8' },
        { value: '颜润明,王崎,等;一种在线视觉引导对位的激光打标系统和激光打标方法;2018.04.13,ZL201721066651.6.' },
        { value: '赖锦祥,钟嘉华,王崎,等;基于特征点匹配的自动测量系统及测量方法;2019.03.05,ZL201610407110.9.' },
        { value: '颜润明,雷亮,王崎,等;多尺度双轴旋转激光影像三维重构系统及其方法;2018.09.25,ZL201510980774.X.' },
        { value: '王建军,王崎,张邦梅,等;发明专利：一种基于对比学习的少样本细粒度图像分类方法,2023.09.19,ZL202310878846.4' },
        { value: '王崎,张家伟,吴雪,王亚洲,等;发明专利：一种基于图文子空间联合学习的植物叶片表型病害分类方法,2024.04.09,ZL202410067314.7' },
        { value: '陈攀峰,陈国军,王崎,等;发明专利：基于语义及关联建模进行实体及提及增强的关系抽取方法,2024.10.01,ZL202411047703.X' },
      ],
      copyrights: [
        { value: '王崎;软件著作权：PlantDRAW 植物病害识别与防控平台,2025.03.10,2025SR0419039' },
        { value: '王崎;软件著作权：PlantPAD 植物表型数据分析平台,2025.02.27' },
        { value: '王崎;软件著作权：多模态植物病害智能诊断系统,2025.04.07,2025SR0577840' },
        { value: '王崎;软件著作权：作物病害基础信息标注软件,2025.04.03,2025SR0568907' },
        { value: '王崎;软件著作权：植物医生平台,2025.04.21,2025SR0649149' },
        { value: '王崎;软件著作权：PlantDRAW 植物病害识别与防控平台,2025.03.10' },
        { value: '王崎;软件著作权：SAMLAB智慧农业与多模态实验室开放平台,2025.07.03,2025R11L1647593' },
        { value: '王崎;软件著作权：CropAgent植物病害智能诊断平台,2025.05.01,2025SR1655343' },
        { value: '王崎;软件著作权：Fragen基于片段的分子生成服务器软件,2025.02.06' },
      ]
    }
  },
  methods: {

  },
  mounted() {
    this.$emit('changeHeight', '200%');
  },
}
</script>

<style scoped>
.patents {
  width: 90%;
  margin-left: -45px;
}

.title-box3 {
  display: flex;
  width: 100%;
  margin-top: 15px;
  align-items: center;
}

.infos {
  margin-top: 10px;
  display: flex;
  line-height: 1.5;
}

.custom-counter {
  font-weight: bold;
  margin-right: 5px;
  min-width: 30px;
}
</style>

```


// WEBPACK FOOTER //
// src/components/Patents.vue